import { render, staticRenderFns } from "./BrandZhiyou.vue?vue&type=template&id=03b4213f&scoped=true&"
import script from "./BrandZhiyou.vue?vue&type=script&lang=js&"
export * from "./BrandZhiyou.vue?vue&type=script&lang=js&"
import style0 from "./BrandZhiyou.vue?vue&type=style&index=0&id=03b4213f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b4213f",
  null
  
)

export default component.exports